// extracted by mini-css-extract-plugin
export default {"CalDotDiv":"CalDots_CalDotDiv__vbAPg","CalDot":"CalDots_CalDot__qzFd2"};